import React from 'react';

import useStyles from './style';
import { profileSettingsTabOptions } from '../../config/userProfileConfig';
import { Typography, Box, List, Modal } from '@material-ui/core';
import VerticalTabs from './verticalTabs';
import ContentBox from '../Layout/ContentBox';


function Setting({ open, handleClose }) {
    const classes = useStyles();
    // console.log("  settings comopnent render +++");
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="personal Setting"
            aria-describedby="personal Setting">
            <Box className={classes.container}>
                <ContentBox title={'Personal Settings'} close handleClose={handleClose} width='70%'>
                    <VerticalTabs options={profileSettingsTabOptions} />
                </ContentBox>
            </Box>
        </Modal>)
}

export default Setting;
